'use client';

import { useEffect } from 'react';
import { getOrCreateVisitorId } from '@/lib/visitor-id';

/**
 * VisitorIdProvider ensures every visitor has a unique ID stored in cookies.
 * This ID is used to associate anonymous actions (like wishlisting) with visitors
 * before they sign up or log in.
 *
 * Place this component near the root of your app (e.g., in the main layout).
 */
export default function VisitorIdProvider() {
  useEffect(() => {
    // Initialize visitor ID on client mount
    // This will create a new ID if one doesn't exist, or retrieve the existing one
    getOrCreateVisitorId();
  }, []);

  // This component doesn't render anything
  return null;
}
